import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLayout, { LegalSection } from '../components/LegalPageLayout';

/**
 * Phase 40 · Termini e Condizioni — versione ufficiale Nymia/Bull Marketing S.r.l.s.
 * Contenuto redatto conformemente a GDPR, DSA (Reg. UE 2022/2065),
 * Codice del Consumo, D.Lgs. 70/2003, Direttiva 2019/770, D.Lgs. 231/2007
 * e Regolamento P2B (UE 2019/1150).
 *
 * Il contenuto vive in `it/legal.json` (chiavi `terms.body.<id>`) così l'ufficio
 * legale può aggiornarlo senza toccare React. La versione EN è tradotta a titolo
 * di cortesia — prevale la versione italiana in caso di divergenza.
 */
const SECTION_IDS = [
  'introduction',
  'definitions',
  'acceptance',
  'platform_role',
  'eligibility',
  'registration',
  'account_security',
  'creator_account',
  'kyc',
  'stripe_payments',
  'wallet',
  'digital_content',
  'live_streaming',
  'one_to_one',
  'creator_responsibility',
  'user_responsibility',
  'intellectual_property',
  'prohibited_content',
  'moderation',
  'reports',
  'disputes',
  'suspension_termination',
  'liability',
  'indemnification',
  'changes',
  'governing_law',
  'contact',
];

// Data di ultima revisione ufficiale del documento.
const LAST_UPDATED = '2026-08-10';

const TermsPage = () => {
  const { t } = useTranslation('legal');
  const sections = SECTION_IDS.map((id) => ({
    id,
    title: t(`terms.sections.${id}`),
  }));

  return (
    <LegalPageLayout
      namespace="legal"
      eyebrow={t('terms.eyebrow')}
      title={t('terms.title')}
      subtitle={t('terms.subtitle')}
      lastUpdated={LAST_UPDATED}
      sections={sections}
      testId="terms-page"
    >
      {SECTION_IDS.map((id) => (
        <LegalSection
          key={id}
          id={id}
          title={t(`terms.sections.${id}`)}
          body={t(`terms.body.${id}`, { defaultValue: '' })}
          testId={`terms-section-${id}`}
        />
      ))}
    </LegalPageLayout>
  );
};

export default TermsPage;
